'use client'

import {
    EmbeddedCheckout,
    EmbeddedCheckoutProvider
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { fetchClientSecret } from '../actions/stripe'
import { useCallback } from 'react'

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY)

export default function Checkout({ projectId, amount, userId }: {projectId: any, amount: any, userId?: any}) {
    const fetchSessionSecret = useCallback(() => {
        // Pass the dynamic ID and amount to your server action
        return fetchClientSecret(projectId, amount, userId)
    }, [projectId, amount])

    return (
        <div id="checkout" className="mt-0 borderf rounded-lg p-4 bg-white">
            <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={{ fetchClientSecret: fetchSessionSecret }}
            >
                <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
        </div>
    )
}